import type {JSONValue} from 'types';

export const arrayToJsonValue = (array: Array<string | number>): JSONValue => {
  return array.reduce((ac, a) => ({...ac, [a]: {}}), {});
};
